// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, of } from 'rxjs';

// --- Hs Code
import { ActivationBaseService } from './activation-base.service';
import { SimpleStringWrapper } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class ActivationMockService extends ActivationBaseService {

  constructor() {
    super();
  }

  resolveToken(token: string): void {
    this._emailAddress$.next('user@email.com');
    this._token$.next('12345');
  }

  activateAccount(token: string): Observable<SimpleStringWrapper> {
    return of({ value: '67890'});
  }
}
